import React from "react";
import Navbar from "../Navbar";
import Issue from "../category/Issue";
import MobileNav from "./MobileNav";
import ScreenNav from "./ScreenNav";
import Comments from "../category/Comments";
import Address from "./Address";
import YourDevice from "../category/YourDevice";
import { useNavigate, useLocation } from "react-router-dom";
const Integration = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const { brandName, modelName, name, description, imageUrl } =
    location.state || {};
  // console.log("Hello this is testing", brandName);

  let Title1 = brandName || "apple";
  const categoryName = sessionStorage.getItem('categoryName');
  let Type = categoryName
  let Brand = brandName || "apple";
  let Model = modelName || "iphone";
  let Title2 = name || "apple";
  let Description2 = description;

  const handleChange = () => {
    navigate("/defects", { state: { ...location.state } });
  };

  const handlePhoneChange = () => {
    navigate("/category",{ state: { ...location.state } });
  };
return (
      <div className="bg-gray-50 min-h-screen flex flex-col">
        <Navbar />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex flex-col gap-12 mt-8">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-32 lg:items-start">
            <div className="lg:hidden block">
              <MobileNav />
            </div>
            <Address />
            <div className="flex flex-col lg:flex-row lg:gap-8 lg:border-l-2 border-t-2 lg:border-t-0">
              <div className="flex flex-col gap-8 lg:gap-12 p-4 lg:pl-8  w-full lg:min-w-[400px]">
                <div className="hidden lg:block">
                  <ScreenNav />
                </div>
                <div className="flex flex-col  border-b border-gray-300 pb-8">
                  <div className="flex justify-between  items-center mb-4">
                    <p className="text-gray-600 font-semibold text-sm">Your Device</p>
                    <button
                      onClick={handlePhoneChange}
                      className="text-yellow-500 font-semibold text-sm cursor-pointer"
                    >
                      Change
                    </button>
                  </div>
                  <YourDevice
                    phone={Title1}
                    type={Type}
                    Brand={Brand}
                    Model={Model}
                  />
                  <div className="flex justify-between   items-center mt-6 mb-2">
                    <p className="text-gray-600 font-semibold text-sm">Your Issue</p>
                    <button
                      onClick={handleChange}
                      className="text-yellow-500 font-semibold text-sm cursor-pointer"
                    >
                      Change
                    </button>
                  </div>
                  <Issue
                    title={Title2}
                    description={Description2}
                    icon={imageUrl}
                  />
                </div>
                <Comments />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    
};

export default Integration;
